import React from 'react';
import { Card, Empty, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import MetricScoreCards from './MetricScoreCards';
import type { DspScoreItem } from '../types';

const { Text } = Typography;

interface Props {
    items: DspScoreItem[];
}

const DspTopList: React.FC<Props> = ({ items }) => {
    const { t } = useTranslation();
    const I18N = 'dashboard.dailyMeeting';

    if (items.length === 0) {
        return <Empty description={t(`${I18N}.dsp.empty`)} />;
    }

    return (
        <div className="flex flex-col gap-3">
            {items.map((dsp) => (
                <Card
                    key={dsp.dspId}
                    size="small"
                    title={
                        <div className="flex items-baseline gap-3">
                            <Text strong>{dsp.dspName}</Text>
                            <Text type="secondary" className="text-xs">
                                {t(`${I18N}.ranking.arrivals`, { value: Number(dsp.actualArrivals).toLocaleString() })}
                            </Text>
                        </div>
                    }
                    extra={<Text strong type="danger">{dsp.totalScore.toFixed(1)}</Text>}
                >
                    <MetricScoreCards metrics={dsp.metrics} showBurst={false} />
                </Card>
            ))}
        </div>
    );
};

export default DspTopList;
